import React from 'react';
import { ElementIcon } from './elementIcon';
import { IIconInfo, IIconItemInfo, IMAGE_TYPE } from '../../interface';
import { classSet } from '@umu/umu-dom';
import { defaultIconColor } from '../../dataFlow';
import './index.scss';

interface IProps extends React.HTMLAttributes<HTMLUListElement> {
    list: IIconItemInfo[];
    info: IIconInfo;
    prefixCls?: string;
    isOnlyShowActive?: boolean;
    onSelectIconFont: (item: IIconItemInfo) => void;
}
function IconFontList(props: IProps) {
    const { list = [], info, prefixCls = 'navigation-icon-font-list-content', isOnlyShowActive = false, onSelectIconFont, ...rest } = props;
    const renderIconFontList = () => {
        return list.map((item, index) => {
            return (
                <li
                    key={index}
                    className={classSet({
                        [`${prefixCls}-item-info`]: true,
                        [`${prefixCls}-item-info-select`]:
                            item.iconName === info.iconName && Number(info.iconType) === IMAGE_TYPE.SVG,
                    })}
                    onClick={() => onSelectIconFont(item)}
                >
                    <div className={classSet({
                        [`${prefixCls}-item-info-zone`]: !isOnlyShowActive,
                        [`${prefixCls}-item-info-zone-show-one`]: isOnlyShowActive,
                    })}>
                        {!isOnlyShowActive && <ElementIcon
                            iconName={item.iconName}
                            color={defaultIconColor}
                            iconType={IMAGE_TYPE.SVG}
                            className={`${prefixCls}-icon-element`}
                        ></ElementIcon>
                        }
                        <ElementIcon
                            iconName={item.activeIconName || item.iconName}
                            color={info.color}
                            iconType={IMAGE_TYPE.SVG}
                            className={`${prefixCls}-icon-element`}
                        ></ElementIcon>
                    </div>
                </li>
            );
        });
    };
    return (
        <ul className={`${prefixCls}`} {...rest}>
            {renderIconFontList()}
        </ul>
    );
}

export { IconFontList };
